/* eslint-disable multiline-ternary */

import { DescriptionTwoTone } from '@mui/icons-material'
import { Button, Typography, Grid, Skeleton, Card, CardMedia, CardContent } from '@mui/material'
import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

const defaultDescription = 'Quisque nisi velit, hendrerit in felis in, convallis pretium ex. In hac habitasse platea dictumst. Vestibulum imperdiet molestie magna, quis sagittis orci.'

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints }) => ({
    title: {
      textTransform: 'capitalize',
      fontSize: typography.heading.h4
    },
    root: {
      marginBottom: spacing(4),
      [breakpoints.down('sm')]: {
        flexDirection: 'row',
        flexWrap: 'wrap'
      }
    },
    counter: {
      background: palette.grey.shade[5],
      padding: spacing(1, 2),
      marginBottom: spacing(2),
      '& .MuiTypography-root': {
        ...typography.body1.xs,
        fontWeight: typography.fontWeightMedium
      }
    },
    resources: {
      [breakpoints.down('sm')]: {
        marginBottom: spacing(1)
      }
    },
    icon: {
      verticalAlign: 'middle',
      marginRight: spacing(0.5)
    },
    resourceText: {
      ...typography.body.s,
      fontWeight: typography.fontWeightMedium,
      color: palette.grey.shade[90]
    },
    descriptionContainer: {
      marginTop: spacing(2),
      [breakpoints.down('md')]: {
        marginBottom: spacing(2)
      }
    },
    imageContainer: {
      marginLeft: spacing(2),
      [breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    image: {
      maxHeight: '220px',
      maxWidth: '392px'
    },
    bottomCaption: {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      color: 'rgba(0, 0, 0, 0.6)'
    }
  })
)
const Header = ({ className = '', category, loading }) => {
  const classes = useStyles()
  const { imageInfo, description } = category ?? {}
  const hasImage = !!imageInfo
  const hasDescription = !!description
  const isDefaultDescription = description === defaultDescription

  return (
    <Grid
      container
      justifyContent='space-between'
      alignItems={hasDescription ? 'flex-start' : 'center'}
      direction='row'
      classes={{ root: classes.root }}
      data-test='description-header'
      wrap='nowrap'
    >
      <Grid item sm={12} md={7} lg={8}>
        <Grid item xs={12} sm={6} lg={12}>
          <Typography
            variant='h4'
            component='h1'
            className={classes.title}
            data-test='description-header-title'
          >
            {category && !loading ? (
              <b>{category.name}</b>
            ) : (
              <Skeleton variant='text' width='5em' />
            )}
          </Typography>
        </Grid>
        {category ? (
          <Grid item xs={12} sm={6} lg={12} data-test='description-header-counter'>
            <Grid
              container
              direction='row'
              alignItems='center'
              wrap='nowrap'
              className={classes.resources}
            >
              <Grid item>
                <DescriptionTwoTone className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography className={classes.resourceText}>
                  <strong>{category.itemsCount ?? 0}</strong>&nbsp;Resources
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Skeleton height='3em'>
            <Button />
          </Skeleton>
        )}
        {!!(hasDescription & !isDefaultDescription) && (
          <Grid item className={classes.descriptionContainer}>
            <Typography
              data-test='description-header-text'
            >
              {category ? (
                description
              ) : (
                <Skeleton variant='text' width='5em' />
              )}
            </Typography>
          </Grid>
        )}
      </Grid>
      {hasImage && (
        <Grid item md={5} lg={4}>
          {imageInfo.imgUrl && (
            <Card
              className={classes.imageContainer}
              data-test='description-header-image-container'
            >
              <CardMedia
                component='img'
                height={220}
                width={392}
                image={imageInfo.imgUrl}
                alt={imageInfo.altText}
                data-test='description-header-image-image'
              />
              {(imageInfo.author || imageInfo.stock) && (
                <CardContent
                  className={classes.bottomCaption}
                  // Removes 24px padding for last child
                  sx={{ p: 1, '&:last-child': { pb: 1 } }}
                >
                  <Typography variant='caption' data-test='description-header-image-credits'>
                    {!!imageInfo.author && `${imageInfo.author}`}
                    {!!imageInfo.author && !!imageInfo.stock && ' / '}
                    {!!imageInfo.stock && imageInfo.stock}
                  </Typography>
                </CardContent>
              )}
            </Card>
          )}
        </Grid>
      )}
    </Grid>
  )
}
export default Header
